/* ============================================================================
   Custom Membership Comparison Section Script
   ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initMembershipComparison();
});

// Re-init on Shopify theme customizer section load
document.addEventListener('shopify:section:load', () => {
  initMembershipComparison();
});

function initMembershipComparison() {
  const comparisonSections = document.querySelectorAll('.membership-comparison');

  comparisonSections.forEach(section => {
    // Avoid duplicate event listener attachments
    if (section.classList.contains('js-initialized')) return;
    section.classList.add('js-initialized');

    const caption = section.querySelector('.membership-comparison__caption');
    if (!caption) return;

    caption.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;

      const href = link.getAttribute('href');
      
      // Determine target element to scroll to
      let targetElement = null;

      if (href && href.startsWith('#') && href.length > 1) {
        // Try finding by exact ID first
        targetElement = document.querySelector(href);
      }

      // Fallback: If href points to FAQ or target wasn't found by ID, target the membership FAQ section
      if (!targetElement && (!href || href === '#' || href.toLowerCase().includes('faq'))) {
        targetElement = document.querySelector('.membership-faq, [id^="MembershipFaq-"], #membership-faq');
      }

      if (targetElement) {
        e.preventDefault();

        // Calculate header offset if fixed/sticky header exists
        const header = document.querySelector('.site-header, header, .header-wrapper, [data-section-type="header"]');
        const headerHeight = header ? header.offsetHeight : 0;
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
}
